import React from 'react';
import {Text, Title} from '../../@FreeModel';

interface IHeader {
  title: string;
  text?: string;
}

const Header = ({text, title}: IHeader): React.ReactElement => {
  return (
    <>
      <Title size="sm" weight="bold" lineHeight="sm" color="orange" style={{marginBottom: 12}}>
        GETTING STARTED
      </Title>

      <Title size="xl" weight="bold" lineHeight="lg" style={{marginBottom: 4}}>
        {title}
      </Title>

      {text !== '' ? (
        <Text color="gray" style={{marginTop: 4}}>
          {text}
        </Text>
      ) : null}
    </>
  );
};

export default Header;
